import z from 'zod';

export type SynonymDto = {
	id: string | null;
	nameSingular: string;
	namePlural: string;
};

export const SynonymDtoSchema: z.ZodType<SynonymDto> = z.object({
	id: z.string().nullable(),
	nameSingular: z.string(),
	namePlural: z.string(),
});
